package com.hyperether.goodjob.scenes.profile

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.navigation.NavHostController
import com.hyperether.goodjob.navigation.*
import com.hyperether.goodjob.repository.prefs.PrefsManager
import com.hyperether.goodjob.repository.remote.model.WorkingHours
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.leave_details
import com.hyperether.goodjob.resources.no_dates_selected
import com.hyperether.goodjob.resources.no_hours_available
import com.hyperether.goodjob.resources.profile_settings
import com.hyperether.goodjob.resources.working_hours
import com.hyperether.goodjob.scenes.components.UserContacts
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.DateTimeUtil.formatWorkingHoursText
import com.hyperether.goodjob.util.DateTimeUtil.groupContiguousWorkingHours
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun ProfileSettings(
    navHostController: NavHostController,
    prefsManager: PrefsManager,
    profileViewModel: ProfileViewModel
) {
    val user by prefsManager.userFlow.collectAsState()

    Box(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .disableMouseDragScrollOnWeb()
            .background(Color.White.copy(alpha = 0.2f))
    ) {

        println("USER" + user.toString())
        Column {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(72.toScaleDp())
                    .padding(horizontal = 16.toScaleDp())
            ) {
                Image(
                    painter = painterResource(Res.drawable.back_arrow),
                    contentDescription = "",
                    modifier = Modifier
                        .align(Alignment.CenterStart)
                        .clickable {
                            navHostController.navigateUp()
                        }
                )

                Text(
                    text = stringResource(Res.string.profile_settings),
                    fontSize = 18.toScaleSp(),
                    color = Color.Black,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.align(Alignment.Center)
                )


                Image(
                    painter = painterResource(Res.drawable.edit),
                    contentDescription = "",
                    modifier = Modifier
                        .align(Alignment.CenterEnd)
                        .clickable {
                            navHostController.navigate(AddNewUser("profileSettings-${user?._id}"))
                        }
                )
            }
            Divider(
                modifier = Modifier.height(2.toScaleDp()).background(BorderColor.copy(alpha = 0.1f))
            )
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(top = 24.toScaleDp()),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                ProfileHeaderView(user)
                Spacer(modifier = Modifier.height(16.toScaleDp()))
                UserContacts(isProfileView = true, user = user)
                val workingHours: WorkingHours? = user?.workingHours
                val workingHoursText = workingHours?.let {
                    val groupedSchedule = groupContiguousWorkingHours(it)
                    formatWorkingHoursText(groupedSchedule)
                }
                Spacer(modifier = Modifier.height(16.toScaleDp()))
                ProfileDetails(
                    stringResource(Res.string.working_hours),
                    if (workingHoursText?.isNotEmpty() == true) workingHoursText else stringResource(
                        Res.string.no_hours_available
                    )
                )
                Spacer(modifier = Modifier.height(16.toScaleDp()))
                ProfileDetails(
                    stringResource(Res.string.leave_details),
                    if (user?.upcomingLeave?.isNotEmpty() == true)
                        DateTimeUtil.formatDateRange(user!!.upcomingLeave!!)
                            ?: stringResource(Res.string.no_dates_selected)
                    else
                        stringResource(Res.string.no_dates_selected)
                )
            }
        }
    }
}